import type { PageMapLens } from "../../enums/map";
import { PAGE_MAP_LENS } from "../../enums/map";

export function PageMapLensToggle(props: {
  lens: PageMapLens;
  setLens: (lens: PageMapLens) => void;
}) {
  return (
    <fieldset class="signal-segment">
      <legend>Page score view</legend>
      <button
        type="button"
        class={`is-primary ${props.lens === PAGE_MAP_LENS.HUMAN ? "is-on" : ""}`}
        onClick={() => props.setLens(PAGE_MAP_LENS.HUMAN)}
      >
        Content Fitness
      </button>
      <button
        type="button"
        class={`is-supporting ${props.lens === PAGE_MAP_LENS.AGENT ? "is-on" : ""}`}
        onClick={() => props.setLens(PAGE_MAP_LENS.AGENT)}
      >
        Agent diagnostic
      </button>
    </fieldset>
  );
}
